import {
  VISIT_LOCATION_OFFICE,
  VISIT_LOCATION_PROJECT,
  VISIT_TYPE_PRESENTIAL,
} from '../constants/visitConstants';
import { OfficeAddress } from '../models/visitsInvestorModel';

// Presential visits use the address of the selected place (office or project);
// virtual visits fall back to the project address.
export const getVisitAddress = (
  visitType: string | null | undefined,
  location: string | null | undefined,
  officeAddress: OfficeAddress | null,
  projectAddress: string,
): string | undefined => {
  if (
    visitType === VISIT_TYPE_PRESENTIAL &&
    (location ?? VISIT_LOCATION_OFFICE) === VISIT_LOCATION_OFFICE
  ) {
    return officeAddress?.address || undefined;
  }
  return projectAddress || undefined;
};

// Visits store the address text as location; map it back to office/project
export const getLocationKey = (
  savedLocation: string | null | undefined,
  projectAddress: string,
): string => {
  if (savedLocation && savedLocation === projectAddress) {
    return VISIT_LOCATION_PROJECT;
  }
  return VISIT_LOCATION_OFFICE;
};
